export default __webpack_public_path__ + "static/sustainability_tuv_mailer-5c0e7c3b8a0e9c4ef64c2244b77363aa.svg";